import { render, staticRenderFns } from "./PerformanceYourInitiatives.vue?vue&type=template&id=4dd5e845&scoped=true&"
import script from "./PerformanceYourInitiatives.vue?vue&type=script&lang=ts&"
export * from "./PerformanceYourInitiatives.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceYourInitiatives.vue?vue&type=style&index=0&id=4dd5e845&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5e845",
  null
  
)

export default component.exports